module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h2', {
    staticStyle: {
      "display": "inline-block"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('el-form', {
    ref: "emailForm",
    staticClass: "template-form",
    attrs: {
      "model": _vm.template,
      "rules": _vm.rules,
      "label-width": "190px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.template.name),
      callback: function($$v) {
        _vm.$set(_vm.template, "name", $$v)
      },
      expression: "template.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Template Type",
      "prop": "type"
    }
  }, [_c('el-select', {
    staticClass: "full-width",
    model: {
      value: (_vm.template.type),
      callback: function($$v) {
        _vm.$set(_vm.template, "type", $$v)
      },
      expression: "template.type"
    }
  }, _vm._l((_vm.templateTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Subject",
      "prop": "subject"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.template.subject),
      callback: function($$v) {
        _vm.$set(_vm.template, "subject", $$v)
      },
      expression: "template.subject"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Body",
      "prop": "content"
    }
  }, [_c('ck-editor', {
    attrs: {
      "config": _vm.editorConfig
    },
    on: {
      "ready": _vm.onEditorReady
    },
    model: {
      value: (_vm.template.content),
      callback: function($$v) {
        _vm.$set(_vm.template, "content", $$v)
      },
      expression: "template.content"
    }
  }), _vm._v(" "), (_vm.template.type) ? _c('div', [_vm._l((_vm.templateVars.global), function(temp) {
    return _c('el-tag', {
      key: temp,
      staticStyle: {
        "margin": "10px 5px"
      },
      attrs: {
        "size": "small"
      }
    }, [_vm._v(_vm._s(("{{" + temp + "}}")) + "\n            ")])
  }), _vm._v(" "), _vm._l((_vm.templateVars[_vm.template.type.toLowerCase()]), function(temp) {
    return _c('el-tag', {
      key: temp,
      staticStyle: {
        "margin": "10px 5px"
      },
      attrs: {
        "size": "small"
      }
    }, [_vm._v(_vm._s(("{{" + temp + "}}")) + "\n            ")])
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.handleFormSave
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _vm._e(), _vm._v("\n              Save\n            ")])], 1), _vm._v(" "), _c('br')])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-169688e7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/automatedemails/templates/TemplateEditor.vue
// module id = 3154
// module chunks = 3